import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import RecentStoryCard from '../member/RecentStoryCard';

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		border: '1px solid #C8CCD1'
	},
	cardTitleText: {
		marginTop: 30,
		marginBottom: 20,
		color: '#333333',
		fontFamily: 'Graphik',
		fontSize: 24,
		fontWeight: 600,
		letterSpacing: 0
	},
	row: {
		marginBottom: 10
	}
});

var decodeHTML = function (html) {
	var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
};

function getStoryTitle(story) {
	if (undefined === story || undefined === story.title || undefined === story.title.rendered ) {
		return "";
	} else {
		return decodeHTML(story.title.rendered);
	}
}

function getRecentStories(member) {
	if (undefined === member.recentStories) {
		return [];
	} else {
		return member.recentStories;
	}
}

function getStoryDate(story) {
	const monthNames = [
		"January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	];

	if (undefined === story || undefined === story.date) {
		return "";
	} else {
		const storyDate = new Date(story.date);
		return monthNames[storyDate.getMonth()].concat(" ", storyDate.getDay());
	}
}

const RecentStoriesCard = ( member ) => {
	const classes = useStyles();

	return (
		<Card className={classes.root} variant="outlined">
			<div className={classes.cardTitleText}>
				Recent Stories
			</div>
			<Grid container spacing={3} className={classes.row}>
				{getRecentStories(member).map((recentStory) => (
					<Grid key={recentStory.id} item xs={12} sm={6} md={4}>
						<RecentStoryCard
								link={recentStory.link}
								imageURL={recentStory.jetpack_featured_media_url}
								title={getStoryTitle(recentStory)}
								storyDate={getStoryDate(recentStory)} />
					</Grid>
					))
				}	
			</Grid>
		</Card>
	);
}

export default RecentStoriesCard;
